import React from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaMinus } from "react-icons/fa";
import Sidebar from "../../SideBar.js";

import axios from "axios";
import { useEffect, useState } from "react";

import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { API_URL } from "../../../../api/index.js";

function LabServiceRegister() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const PackageID = useLocation().pathname.split("/")[2];
  const [treatmentLists, setTreatmentLists] = useState([]);
  const [unitArr, setUnitArr] = useState([]);
  const [unitLists, setUnitLists] = useState([]);
  const [showUnitLists, setShowUnitLists] = useState([]);
  const [name, setName] = useState("");
  const [cost, setCost] = useState("");
  const [charges, setCharges] = useState("");
  const [status, setStatus] = useState("");
  const [packageLists, setPackageLists] = useState([]);
  const [packageSellingPrice, setPackageSellingPrice] = useState("");
  const [description, setDescription] = useState("");
  const [tempPackage, setTempPackage] = useState("");
  const [showUnit, setShowUnit] = useState(false);
  const [treatmentUnit, setTreatmentUnit] = useState("");
  const [upUnitLists, setUpUnitLists] = useState([]);
  const [totalPrice, setTotalPrice] = useState("");
  const [totalCost, setTotalCost] = useState("");
  const [upTotalPrice, setUpTotalPrice] = useState("");
  const [upTotalCost, setUpTotalCost] = useState("");
  const [finalTotalPrice, setFinalTotalPrice] = useState("");
  const [pkgDiscountPercentage, setPkgDiscountPercentage] = useState(0);
  const [pkgDiscountAmount, setPkgDiscountAmount] = useState(0);
  const [sellingPrice, setSellingPrice] = useState(0);
  const [eventUnified, setEventUnified] = useState("Yes");

  var sumCost = 0;
  var sumPrice = 0;

  var sumUpCost = 0;
  var sumUpPrice = 0;

  const [price, setPrice] = useState("");
  const [Id, setId] = useState("");

  const handleAdd = (Id) => {
    setId(Id);
  };
  const handleBox = (event) => {
    const selected = showUnitLists.find((el) => el._id == event);

    const newItem = {
      id: event,
      name: selected?.name || "",
      price: Number(selected?.estimateTotalPrice || 0),
      sellingPrice: Number(selected?.sellingPrice || 0),
      originalSellingPrice: Number(selected?.sellingPrice || 0),
      qty: 1,
      unitDiscountPercentage: 0,
      fromOld: false,
    };

    const allUnits = [...upUnitLists, ...unitArr];

    const existingIndex = allUnits.findIndex((item) => item.id == event);

    let updated;

    if (existingIndex !== -1) {
      updated = allUnits.map((item) =>
        item.id == event ? { ...item, qty: (item.qty || 1) + 1 } : item,
      );
    } else {
      updated = [...allUnits, newItem];
    }

    recalculateAll(updated);
  };

  const navigate = useNavigate();

  const TestPackageUpdate = (event) => {
    event.preventDefault();

    const treatmentForPackage = [
      ...(upUnitLists || []).map((item) => ({
        treatment: item.id,
        sellingPrice: item.sellingPrice,
        qty: item.qty || 1,
        discountPercent: Number(item.unitDiscountPercentage) || 0,
      })),
      ...(unitArr || []).map((item) => ({
        treatment: item.id,
        sellingPrice: item.sellingPrice,
        qty: item.qty,
        discountPercent: Number(item.unitDiscountPercentage) || 0,
      })),
    ];

    const data = {
      id: PackageID,
      name: name,
      description: description,
      totalPrice: totalPrice,
      totalCost: totalCost,
      discountPercent: pkgDiscountPercentage,
      discountAmount: pkgDiscountAmount,
      sellingPrice: sellingPrice,
      status: status.toLowerCase(),
      treatmentForPackage,
      isEvenUnified: eventUnified === "Yes",
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .put("package", data, config)
      .then(function () {
        Swal.fire({
          title: "Success",
          text: "Package successfully updated!",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/package");
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err.response?.data?.message || "Error",
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleUnit = (event) => {
    setShowUnitLists(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == event,
      ),
    );

    setShowUnit(true);

    console.log(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == event,
      ),
    );
  };

  const removeBox = (id) => {
    const allUnits = [...upUnitLists, ...unitArr];
    const updated = allUnits.filter((item) => item.id !== id);

    recalculateAll(updated);
  };

  useEffect(() => {
    const getTreatment = async () => {
      try {
        const res = await api.get("treatment-lists");

        setTreatmentLists(res.data.list);
        console.log(res.data.list, "treat list");
      } catch (err) {}
    };

    const getUnitLists = async () => {
      try {
        const res = await api.get("treatments");

        setUnitLists(res.data.list);
      } catch (err) {}
    };

    const getPackageLists = async () => {
      try {
        const res = await api.get("package/" + PackageID);
        console.log(res.data.data[0], "pack up list");

        setName(res.data.data[0].name);
        setTotalCost(res.data.data[0].totalCost);
        setTotalPrice(res.data.data[0].totalPrice);
        setPackageSellingPrice(res.data.data[0].sellingPrice);
        setStatus(res.data.data[0].status);
        setDescription(res.data.data[0].description);
        setStatus(res.data.data[0].status);

        // setPackageLists(res.data.data)

        if (
          res.data.data[0].relatedTreatments !== null &&
          res.data.data[0].relatedTreatments.length > 0
        ) {
          const pkg = res.data.data[0];

          const treatments = pkg.relatedTreatments || [];
          const packageData = pkg.treatmentForPackage || [];

          setEventUnified(pkg.isEvenUnified ? "Yes" : "No");

          const newData = treatments.map((treatment) => {
            const matched = packageData.find(
              (p) => p.treatment === treatment._id,
            );

            return {
              name: treatment.name || "",
              id: treatment._id,
              qty: matched?.qty || 1,
              unitDiscountPercentage: matched?.discountPercent || 0,
              price: treatment.estimateTotalPrice || 0,
              sellingPrice:
                matched?.sellingPrice || treatment.sellingPrice || 0,
              originalSellingPrice:
                treatment.sellingPrice || matched?.sellingPrice || 0,
              fromOld: true,
            };
          });

          setUpUnitLists(newData);
          setShowUnit(true);
        }
      } catch (err) {}
    };

    getPackageLists();
    getUnitLists();
    getTreatment();
  }, []);

  useEffect(() => {
    const price = Number(totalPrice) || 0;
    const percent = Number(pkgDiscountPercentage) || 0;

    const discount = (price * percent) / 100;
    const finalPrice = price - discount;

    setPkgDiscountAmount(discount);
    setSellingPrice(finalPrice);
  }, [totalPrice, pkgDiscountPercentage]);

  useEffect(() => {
    if (unitArr.length === 0) return;

    const discountPerUnit = Number(pkgDiscountAmount) / unitArr.length || 0;

    const updatedUnitArr = unitArr.map((item) => {
      const newSellingPrice =
        Number(item.originalSellingPrice) - discountPerUnit;

      const unitDiscountPercentage =
        ((item.originalSellingPrice - newSellingPrice) /
          item.originalSellingPrice) *
        100;

      return {
        ...item,
        sellingPrice: newSellingPrice,
        unitDiscountPercentage: unitDiscountPercentage.toFixed(2),
      };
    });

    setUnitArr(updatedUnitArr);
  }, [pkgDiscountAmount]);

  useEffect(() => {
    const allUnits = [...upUnitLists, ...unitArr];
    if (allUnits.length === 0) return;

    recalculateAll(allUnits);
  }, [eventUnified]);

  const recalculateAll = (updatedUnits) => {
    if (!updatedUnits || updatedUnits.length === 0) {
      setUnitArr([]);
      setUpUnitLists([]);
      setTotalPrice(0);
      setSellingPrice(0);
      setTotalCost(0);
      return;
    }

    let finalArr = [];

    if (eventUnified === "Yes") {
      const totalQty = updatedUnits.reduce(
        (acc, item) => acc + (item.qty || 1),
        0,
      );

      finalArr = updatedUnits.map((item) => ({
        ...item,
        unitDiscountPercentage: (((item.qty || 1) * 100) / totalQty).toFixed(2),
        sellingPrice: item.originalSellingPrice || item.sellingPrice,
      }));
    } else {
      finalArr = updatedUnits.map((item) => {
        const discountPercent = Math.min(
          Number(item.unitDiscountPercentage) || 0,
          100,
        );

        const discountedPrice =
          (item.originalSellingPrice || 0) * (1 - discountPercent / 100);

        return {
          ...item,
          unitDiscountPercentage: discountPercent,
          sellingPrice: discountedPrice,
        };
      });
    }

    const newTotalPrice = finalArr.reduce(
      (acc, item) =>
        acc + (item.originalSellingPrice || item.sellingPrice) * item.qty,
      0,
    );

    const newSellingPrice = finalArr.reduce(
      (acc, item) => acc + item.sellingPrice * item.qty,
      0,
    );

    const newTotalCost = finalArr.reduce(
      (acc, item) => acc + item.price * item.qty,
      0,
    );

    setUpUnitLists(finalArr.filter((item) => item.fromOld));
    setUnitArr(finalArr.filter((item) => !item.fromOld));

    setTotalPrice(newTotalPrice);
    setSellingPrice(newSellingPrice);
    setTotalCost(newTotalCost);
  };
  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/package">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active mt-1">
                      Package Register
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              {/* <!-- Small boxes (Stat box) --> */}
              <div class="card">
                {/* <h3 className="text-center py-3">Test Package Register</h3> */}
                <div class="card-body p-b-0 py-5 px-5">
                  {/* @if($com == null) */}
                  <form onSubmit={TestPackageUpdate}>
                    {/* @csrf */}
                    <div className="form-body">
                      <div className="form-group">
                        <label>Package Name</label>
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          defaultValue={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <label className="control-label">
                            Add Treatments
                          </label>
                          <div className="row d-flex justify-content-between">
                            <div className="col-md-5">
                              <select
                                class="custom-select border-info"
                                name="account_type_id"
                                id="flag"
                                // placeHolder='Treatments'
                                onChange={(e) => {
                                  handleUnit(e.target.value);
                                }}
                              >
                                <option value="">Choose Treatments</option>
                                {treatmentLists.map((option) => (
                                  <option value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {showUnit && (
                              <div className="col-md-5">
                                <select
                                  class="custom-select border-info"
                                  name="account_type_id"
                                  id="flag"
                                  onChange={(e) => {
                                    handleAdd(e.target.value);
                                  }}
                                >
                                  <option value="">Choose Unit</option>
                                  {showUnitLists.map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            <div className="col-md-1">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => handleBox(Id)}
                              >
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          {unitArr ? (
                            <div>
                              {unitArr.map((regArr, index) => (
                                <div className="row mt-3" key={regArr.id}>
                                  <div className="col-md-3">
                                    <label>Unit Name</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.name}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-1">
                                    <label>Qty</label>
                                    <input
                                      type="text"
                                      value={regArr.qty}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Price</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.price}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Selling Price</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.sellingPrice}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Discount Percentage</label>
                                    <input
                                      type="text"
                                      value={
                                        regArr.unitDiscountPercentage
                                          ? regArr.unitDiscountPercentage
                                          : "0.00"
                                      }
                                      className="form-control"
                                      readOnly={eventUnified === "Yes"}
                                      onChange={(e) => {
                                        const value = Number(e.target.value);

                                        if (value > 100) return;

                                        const allUnits = [
                                          ...upUnitLists,
                                          ...unitArr,
                                        ];

                                        const updated = allUnits.map((item) =>
                                          item.id === regArr.id
                                            ? {
                                                ...item,
                                                unitDiscountPercentage: value,
                                              }
                                            : item,
                                        );

                                        recalculateAll(updated);
                                      }}
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <button
                                      type="button"
                                      onClick={() => removeBox(regArr.id)}
                                      className="btn btn-sm btn-danger rounded-circle opacity-75"
                                      style={{ marginTop: "2.5em" }}
                                    >
                                      <FaMinus />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            ""
                          )}
                          {upUnitLists && (
                            <div>
                              {upUnitLists.map((regArr, index) => (
                                <div className="row mt-3" key={regArr.id}>
                                  <div className="col-md-3">
                                    <label>Unit Name</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.name}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-1">
                                    <label>Qty</label>
                                    <input
                                      type="text"
                                      value={regArr.qty}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label>Price</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.price}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Selling Price</label>
                                    <input
                                      type="text"
                                      defaultValue={regArr.sellingPrice}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Discount Percentage</label>
                                    <input
                                      type="text"
                                      value={
                                        regArr.unitDiscountPercentage
                                          ? regArr.unitDiscountPercentage
                                          : "0.00"
                                      }
                                      className="form-control"
                                      readOnly={eventUnified === "Yes"}
                                      onChange={(e) => {
                                        const value = Number(e.target.value);

                                        if (value > 100) return;

                                        const allUnits = [
                                          ...upUnitLists,
                                          ...unitArr,
                                        ];

                                        const updated = allUnits.map((item) =>
                                          item.id === regArr.id
                                            ? {
                                                ...item,
                                                unitDiscountPercentage: value,
                                              }
                                            : item,
                                        );

                                        recalculateAll(updated);
                                      }}
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <button
                                      type="button"
                                      onClick={() => removeBox(regArr.id)}
                                      className="btn btn-sm btn-danger rounded-circle opacity-75"
                                      style={{ marginTop: "2.5em" }}
                                    >
                                      <FaMinus />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="form-group mt-2">
                        <label>Event unified</label>

                        <div>
                          <label style={{ marginLeft: "10px" }}>
                            <input
                              type="radio"
                              name="perUnit"
                              value="Yes"
                              checked={eventUnified === "Yes"}
                              onChange={(e) => setEventUnified(e.target.value)}
                            />
                            Yes
                          </label>
                          <label style={{ marginLeft: "10px" }}>
                            <input
                              type="radio"
                              name="perUnit"
                              value="No"
                              checked={eventUnified === "No"}
                              onChange={(e) => setEventUnified(e.target.value)}
                            />
                            No
                          </label>
                        </div>
                      </div>
                      <div className="form-group">
                        <label>Total Cost</label>
                        <input
                          type="number"
                          id="cost"
                          className="form-control"
                          defaultValue={
                            upUnitLists ? totalCost + upTotalCost : totalCost
                          }
                          onChange={(e) => setCost(e.target.value)}
                        />
                      </div>
                      <div className="form-group mt-3">
                        <label>Total Package Selling Price</label>
                        <input
                          type="number"
                          id="charge"
                          className="form-control"
                          value={
                            upUnitLists ? totalPrice + upTotalPrice : totalPrice
                          }
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="status"
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option hidden>{status}</option>
                          <option value="Active">Active</option>
                          <option value="Pending">Pending</option>
                        </select>
                      </div>

                      <div className="col-md-12">
                        <label>Description</label>
                        <textarea
                          rows="8"
                          cols="40"
                          id="desc"
                          className="form-control"
                          defaultValue={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>

                      <div className="form-actions mt-3">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row">
                              <div className=" col-md-9">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Update
                                </button>
                                &nbsp;
                                <Link
                                  to="/package"
                                  className="btn btn-danger"
                                  data-dismiss="modal"
                                >
                                  Cancel
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <!-- /.row (main row) --> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </div>
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>

        {/* <!-- /.content-wrapper --> */}

        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default LabServiceRegister;
